(ns shared.core.amelia-light.components.table
  (:require [shared.core.style :as style]
            [shared.core.util :as util]
            [shared.core.amelia-light.components.card :as card]
            [shared.core.amelia-light.components.loading :as loading]
            [shared.core.components.table :as table]))

(def table-header-style
  {:background-color :transparent
   :display :flex
   :align-items :center
   :padding "8px 0 8px 12px"
   :font-family style/roboto-font-family
   :font-size 12
   :line-height 1.33
   :letter-spacing :none
   :font-weight style/font-regular-weight
   :text-transform :none
   :color (util/hex->rgba (style/color :on-background :base) 0.4)
   :transition "flex 0.2s"})

(def table-cell-style
  {:background-color :transparent
   :padding "0 0 0 12px"
   :font-family style/roboto-font-family
   :font-size 12
   :line-height 1.5
   :letter-spacing "0px"
   :font-weight style/font-regular-weight
   :color (util/hex->rgba (style/color :black :base) 0.8)
   :transition "flex 0.2s"})

(defn table
  [{:keys [headers rows container-loading? loading-label header-top header-style row-style no-data-text-style
           no-data-style loader-container-style loader-cell-style style]
    :as args}]
  (let [border-divider-secondary (str "1px solid " (style/alc-color "Border/divider_secondary"))]
    (if container-loading?
      [card/card {:style {:flex 1
                          :height "100%"
                          :width "100%"}}
       [loading/up-loader-with-label {:label (or loading-label "Loading Data...")}]]
      [table/table (merge {:no-data-material-icon :hide-source
                           :no-data-style (merge {:display :flex
                                                  :flex-direction :column
                                                  :align-items :center
                                                  :justify-content :center
                                                  :gap 4
                                                  :width "100%"
                                                  :min-height "100%"
                                                  :flex 1
                                                  :opacity 1}
                                                 no-data-style)
                           :no-data-icon-style {:font-size 24
                                                :color (style/alc-color "Icons/secondary")
                                                :opacity 1}
                           :no-data-text-style (merge {:color (style/alc-color "Text/secondary")
                                                       :font-size 16
                                                       :font-weight 400
                                                       :line-height 1.4
                                                       :opacity 1}
                                                      no-data-text-style)
                           :loading-more-content [loading/up-loader-with-label {:label "Loading More..."
                                                                                :loader-size "small"
                                                                                :style {:flex-direction :row
                                                                                        :padding 20}}]
                           :loader-container-style (merge {:padding "6px 12px"}
                                                          loader-container-style)
                           :loader-cell-style (merge {:padding 0
                                                      :margin-left 12}
                                                     loader-cell-style)
                           :loader-content-height 15
                           :bottom-px-buffer 200
                           :style (merge {:border border-divider-secondary
                                          :border-radius 12
                                          :overflow :clip
                                          :flex 1}
                                         style)
                           :scroll-container-style {:flex 1}
                           :expandable-icon-style {:color (style/alc-color "Icons/secondary")}
                           ;; Top margin overlays the container's top border; horizontal
                           ;; negative margins would overflow the x-scroll container by 1px
                           ;; and force a permanent horizontal scrollbar.
                           :header-style (merge {:background-color (style/alc-color "Background/card_hex")
                                                 :border-bottom :none
                                                 :margin "-1px 0 0"
                                                 :padding 0
                                                 :top (or header-top 0)
                                                 :height 28
                                                 :z-index (dec (style/z :medium))}
                                                header-style)
                           :row-container-style (when (empty? rows)
                                                  {:background-color :transparent
                                                   :flex 1
                                                   :display :flex
                                                   :flex-direction :column})
                           :row-style (merge {:background-color :transparent
                                              :border-bottom border-divider-secondary
                                              :color (style/alc-color "Text/primary")
                                              :height :auto
                                              :align-items :flex-start
                                              :padding "8px 0"}
                                             row-style)
                           :headers (map-indexed (fn [idx header]
                                                   (assoc (if (map? header) header {:label header})
                                                     :style (cond-> (merge table-header-style
                                                                           {:border-top border-divider-secondary
                                                                            :border-bottom border-divider-secondary
                                                                            :color (style/alc-color "Text/secondary")}
                                                                           (:style header))
                                                                    (= idx (dec (count headers)))
                                                                    (assoc :padding "8px 12px"))))
                                                 headers)
                           :rows (map-indexed (fn [idx {:keys [cells style hover-style] :as row}]
                                                (merge row
                                                       {:cells (mapv (fn [cell]
                                                                       (assoc (if (map? cell) cell {:label cell})
                                                                         :style (merge table-cell-style
                                                                                       (when (string? (:label cell))
                                                                                         {:overflow :hidden
                                                                                          :text-overflow :ellipsis
                                                                                          :display :inline-block})
                                                                                       {:color (style/alc-color "Text/primary")}
                                                                                       (:style cell))))
                                                                     cells)
                                                        :style (cond-> style
                                                                       (= idx (dec (count rows)))
                                                                       (assoc :border-bottom :none))
                                                        :hover-style (merge {:background-color (style/alc-color "Background/hover")}
                                                                            hover-style)
                                                        :actions-use-up-style? true}))
                                              rows)}
                          (dissoc args
                                  :no-data-style :no-data-text-style :loader-container-style :loader-cell-style
                                  :header-style :row-style :headers :rows :scroll-container-style))])))
